/* eslint-disable no-unused-vars */
import Sidebar from '../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import { Button, message } from 'antd';
import { Formik } from 'formik';
import { InputFromUser } from '../../../components/Input/input';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { GetAdminUserDetailsList, getAdminuUerDetails } from '../../../store/Actions/AuthActions';
import { AddLeaveValidationSchema } from '../../../utils/FormValidation';
import { ActionCreateByUrl } from '../../../store/Actions/CommonAction';
import dayjs from 'dayjs';

const AddLeave = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetailList } = useSelector(state => state?.auth);
  const { userDetails } = useSelector(state => state?.auth);
  const userId = userDetails?.[0]?._id;
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    try {
      dispatch(getAdminuUerDetails());
      dispatch(GetAdminUserDetailsList());
    } catch (error) {
      message.error('Failed to load user details. Please refresh the page.');
      console.error('Error loading user details:', error);
    }
  }, [dispatch]);

  const calculateDays = (fromDate, toDate, isHalfDay) => {
    if (!fromDate || !toDate) return 0;

    try {
      const start = new Date(fromDate);
      const end = new Date(toDate);

      // Validate dates
      if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        return 0;
      }

      const timeDifference = end.getTime() - start.getTime();
      const daysDifference = timeDifference / (1000 * 3600 * 24);
      const totalDays = Math.ceil(daysDifference) + 1; // Include both start and end dates

      // If it's a half day and dates are same, return 0.5
      if (isHalfDay === 'Half day' && start.toDateString() === end.toDateString()) {
        return 0.5;
      }

      return totalDays;
    } catch (error) {
      console.error('Error calculating days:', error);
      return 0;
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/leaves">Staffs </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Add Leave Request</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <Formik
                      initialValues={{
                        leaveType: '',
                        fromDate: '',
                        toDate: '',
                        adminId: '',
                        adminName: '',
                        adminType: '',
                        reason: '',
                        noOfDays: 0,
                        status: 'Pending',
                        isHalfDay: '',
                        startTime: null,
                        endTime: null,
                      }}
                      validationSchema={AddLeaveValidationSchema}
                      onSubmit={async (values, { setErrors, setSubmitting }) => {
                        try {
                          setIsSubmitting(true);

                          // Find admin info
                          const AdminInfo = userDetailList?.[0]?.find(
                            v => v?.name === values?.adminName
                          );

                          if (!AdminInfo) {
                            message.error('Selected admin not found. Please try again.');
                            setSubmitting(false);
                            setIsSubmitting(false);
                            return;
                          }

                          // Prepare payload
                          const payload = {
                            ...values,
                            isHalfDay: values?.isHalfDay === 'Half day',
                            adminId: AdminInfo?.id,
                            adminName: AdminInfo?.name,
                            adminType: AdminInfo?.type,
                            createdBy: userId,
                            // Convert dayjs objects to formatted time strings
                            startTime: values?.startTime && dayjs.isDayjs(values.startTime)
                              ? values.startTime.format('h:mm a')
                              : values?.startTime,
                            endTime: values?.endTime && dayjs.isDayjs(values.endTime)
                              ? values.endTime.format('h:mm a')
                              : values?.endTime,
                          };

                          dispatch(
                            ActionCreateByUrl(
                              {
                                Query: 'admin/leaves',
                                obj: payload,
                              },
                              Res => {
                                setSubmitting(false);
                                setIsSubmitting(false);

                                if (Res?.statusCode === 200) {
                                  message.success('Leave request submitted successfully!');
                                  setTimeout(() => {
                                    navigate('/leaves');
                                  }, 1000);
                                } else if (Res?.statusCode === 400) {
                                  // Handle validation errors from backend
                                  if (Res?.data?.errors) {
                                    setErrors(Res.data.errors);
                                  }

                                  // Check for duplicate key error
                                  const errorMessage = Res?.data?.error || Res?.message || '';
                                  if (errorMessage.includes('E11000') || errorMessage.includes('duplicate key')) {
                                    if (errorMessage.includes('fromDate')) {
                                      message.error('A leave request already exists for this start date. Please choose a different date or edit the existing leave.');
                                      setErrors({
                                        fromDate: 'A leave already exists for this date'
                                      });
                                    } else {
                                      message.error('A leave request with these details already exists. Please check and try again.');
                                    }
                                  } else {
                                    message.error(Res?.message || 'Failed to submit leave request. Please check the form.');
                                  }
                                } else {
                                  message.error('An unexpected error occurred. Please try again.');
                                }
                              }
                            )
                          );
                        } catch (error) {
                          console.error('Error submitting leave request:', error);
                          message.error('Failed to submit leave request. Please try again.');
                          setSubmitting(false);
                          setIsSubmitting(false);
                        }
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setValues,
                        isSubmitting,
                      }) => {
                        const handleDateChange = (fieldName, dateValue) => {
                          const updatedValues = {
                            ...values,
                            [fieldName]: dateValue,
                          };

                          if (fieldName === 'fromDate' || fieldName === 'toDate') {
                            updatedValues.noOfDays = calculateDays(
                              updatedValues.fromDate,
                              updatedValues.toDate,
                              updatedValues.isHalfDay
                            );
                          }

                          setValues(updatedValues);
                        };

                        const handleDayTypeChange = value => {
                          const updatedValues = {
                            ...values,
                            isHalfDay: value,
                          };

                          // Recalculate days based on day type
                          updatedValues.noOfDays = calculateDays(
                            updatedValues.fromDate,
                            updatedValues.toDate,
                            value
                          );

                          setValues(updatedValues);
                        };

                        return (
                          <div>
                            <div className="row">
                              <InputFromUser
                                label="Leave Type"
                                type="singleSelect"
                                name="leaveType"
                                onChange={value => {
                                  handleChange({
                                    target: {
                                      name: 'leaveType',
                                      value,
                                    },
                                  });
                                }}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'leaveType',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values?.leaveType}
                                error={errors?.leaveType}
                                options={['Casual Leave', 'Sick Leave', 'Leave Without Pay']}
                                touched={touched.leaveType}
                                placeholder={'Select Leave Type'}
                              />

                              <InputFromUser
                                label="Employee Name"
                                type="singleSelect"
                                name="adminId"
                                onChange={value => {
                                  handleChange({
                                    target: {
                                      name: 'adminName',
                                      value,
                                    },
                                  });
                                }}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'adminName',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.adminName}
                                error={errors.adminName}
                                touched={touched.adminName}
                                options={userDetailList?.[0]?.map(v => v?.name) || []}
                                placeholder={'Select Employee'}
                              />
                              <InputFromUser
                                label="From Date"
                                type="date"
                                name="fromDate"
                                onChange={value => {
                                  handleDateChange('fromDate', value);
                                }}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'fromDate',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.fromDate}
                                error={errors.fromDate}
                                touched={touched.fromDate}
                                placeholder={'Select From Date'}
                              />

                              <InputFromUser
                                label="To Date"
                                type="date"
                                name="toDate"
                                onChange={value => handleDateChange('toDate', value)}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'toDate',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.toDate}
                                error={errors.toDate}
                                touched={touched.toDate}
                                placeholder={'Select To Date'}
                              />

                              <InputFromUser
                                label="Day Type"
                                type="radio"
                                name="isHalfDay"
                                onChange={value => {
                                  handleDayTypeChange(value);
                                }}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'isHalfDay',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.isHalfDay}
                                selectedValue={values.isHalfDay}
                                error={errors.isHalfDay}
                                touched={touched.isHalfDay}
                                options={['full day', 'Half day', 'Long Holiday'].map(option => ({
                                  label: option,
                                  value: option,
                                }))}
                                placeholder={'Select Day Type'}
                              />

                              <InputFromUser
                                label="No Of Days"
                                type="number"
                                name="noOfDays"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.noOfDays}
                                error={errors.noOfDays}
                                touched={touched.noOfDays}
                                placeholder={'No Of Days'}
                                disabled
                              />


                              {/* Always show time fields */}
                              <InputFromUser
                                label="Start Time"
                                type="TimePicker"
                                name="startTime"
                                onChange={value => {
                                  handleChange({
                                    target: {
                                      name: 'startTime',
                                      value,
                                    },
                                  });
                                }}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'startTime',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.startTime}
                                error={errors.startTime}
                                touched={touched.startTime}
                                placeholder={'Select Start Time'}
                              />

                              <InputFromUser
                                label="End Time"
                                type="TimePicker"
                                name="endTime"
                                onChange={value => {
                                  handleChange({
                                    target: {
                                      name: 'endTime',
                                      value,
                                    },
                                  });
                                }}
                                onBlur={value => {
                                  handleBlur({
                                    target: {
                                      name: 'endTime',
                                      value: true,
                                    },
                                  });
                                }}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.endTime}
                                error={errors.endTime}
                                touched={touched.endTime}
                                placeholder={'Select End Time'}
                              />

                              <InputFromUser
                                label="Reason for Leave"
                                type="text"
                                name="reason"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-12 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                value={values.reason}
                                error={errors.reason}
                                touched={touched.reason}
                                placeholder={'Enter Reason for Leave'}
                              />

                              <div className="col-12 mt-5">
                                <div className="text-end">
                                  <Button
                                    onClick={() => navigate('/leaves')}
                                    className="me-2"
                                    disabled={isSubmitting}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      handleSubmit();
                                    }}
                                    type="primary"
                                    disabled={isSubmitting}
                                    loading={isSubmitting}
                                    className="me-2"
                                  >
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLeave;
